/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_MetaInputs */

const en_us2_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tape · cm`)
};

const pt_br2_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fita métrica · cm`)
};

const es_419_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinta métrica · cm`)
};

const pt_pt2_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fita métrica · cm`)
};

const fr_fr2_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mètre ruban · cm`)
};

const de_de2_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maßband · cm`)
};

const it_it2_body_measures_meta = /** @type {(inputs: Body_Measures_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metro da sarto · cm`)
};

/**
* | output |
* | --- |
* | "Tape · cm" |
*
* @param {Body_Measures_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_meta = /** @type {((inputs?: Body_Measures_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_meta(inputs)
	if (locale === "es-419") return es_419_body_measures_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_meta(inputs)
	if (locale === "de-DE") return de_de2_body_measures_meta(inputs)
	if (locale === "it-IT") return it_it2_body_measures_meta(inputs)
	return en_us2_body_measures_meta(inputs)
});
export { body_measures_meta as "body-measures.meta" }